export enum ParkerAccessDeviceTypeDisplayEnum {
	'Proximity Card' = 'PROXIMITY_CARD',
	'Tenant Access Card' = 'TENANT_ACCESS_CARD',
	'AVI Transponder' = 'AVI_TRANSPONDER',
	'Hang Tag' = 'HANG_TAG',
	'Windshield Sticker' = 'WINDSHIELD_STICKER',
	Barcode = 'BARCODE',
	'Flash Parking App' = 'FLASH_PARKING_APP',
	'License Plate Recognition' = 'LICENSE_PLATE_RECOGNITION',
}
